import { combineReducers } from 'redux';

import { reducer as incidentSummary } from './incidentSummaryModule';

export default combineReducers({
	incidentSummary,
});
